import { useContext } from "react"
import { MatchingObject, WebProvider } from "../../websocket/wsProvider"

/**
 *
 * @param {WebProvider} webProvider
 * @param {function} sendMessage
 * @param {function} subscribe
 * @param {function} unsubscribe
 * @param {basicController} controller
 */
function UseWebProviderReturn(
	webProvider,
	sendMessage,
	subscribe,
	unsubscribe,
	controller,
	connectSocket,
	connectNotificationSocket,
	handleLogout,
	notificationSocket,
	unsubscribeEvent,
	subscribeEvent
) {
	this.webProvider = webProvider
	this.sendMessage = sendMessage
	this.subscribe = subscribe
	this.unsubscribe = unsubscribe
	this.controller = controller
	this.connectSocket = connectSocket
	this.connectNotificationSocket = connectNotificationSocket
	this.handleLogout = handleLogout
	this.notificationSocket = notificationSocket
	this.subscribeEvent = subscribeEvent
	this.unsubscribeEvent = unsubscribeEvent
}

/**
 *
 * @param {string} matchingContext
 * @param {funtion} refresherFunction
 * @returns {UseWebProviderReturn}
 */
export const useWebProvider = () => {
	/**
	 * @type {WebProvider}
	 */
	const webProvider = useContext(WebProvider)

	/**
	 *
	 * @param {MatchingObject} matchObject
	 */
	const subscribe = (matchObject) => {
		webProvider.subscribe(matchObject)
	}
	const unsubscribe = (matchObject) => {
		webProvider.unsubscribe(matchObject)
	}
	const subscribeEvent = (context, location, eventHandler) => {
		webProvider.subscribeEvent(context, location, eventHandler)
	}
	const unsubscribeEvent = (context, location, eventHandler) => {
		webProvider.unsubscribeEvent(context, location, eventHandler)
	}
	const sendMessage = (matchObject) => {
		webProvider.sendMessage(matchObject)
	}
	const connectSocket = (userName, company) => {
		webProvider.connectSocket(userName, company)
	}
	const connectNotificationSocket = (userName, company) => {
		webProvider.connectNotificationSocket(userName, company)
	}
	const handleLogout = () => {
		webProvider.handleLogout()
	}

	

	return {
		socket: webProvider.socket,
		notificationSocket: webProvider.notificationSocket,
		sendMessage,
		subscribe,
		unsubscribe,
		controller: webProvider.basicController,
		connectSocket,
		connectNotificationSocket,
		handleLogout,
		subscribeEvent,
		unsubscribeEvent,
		wsProvider : webProvider

	}
}
